import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=6b260327&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=6b260327&prod&scoped=true&lang=css"
import style1 from "./Product.vue?vue&type=style&index=1&id=6b260327&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b260327",
  null
  
)

export default component.exports